import { extend, useFrame, useThree } from "@react-three/fiber";
import { useRef, useEffect, useState } from "react";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as THREE from 'three';
import { useMapStore } from "../../store/useMapStore.js";
extend({ OrbitControls });

function Controls() {
  const { camera, gl } = useThree();
  const controlsRef = useRef();
  
  useEffect(() => {
    if (controlsRef.current) {
      controlsRef.current.enableDamping = true;
      controlsRef.current.dampingFactor = 0.1;
      controlsRef.current.dampingFactor = 0.1;
      controlsRef.current.maxDistance = 2000;
      controlsRef.current.minDistance = 50;
    }
  }, []);
  
  useFrame(() => {
    controlsRef.current && controlsRef.current.update();
  });
  
  return <orbitControls ref={controlsRef} args={[camera, gl.domElement]} />;
}

export default function Map3DPlane({ mapImage, isDarkBackground = false, showGrid = false }) {
  const planeRef = useRef();
  const gridRef = useRef();
  const { camera, gl } = useThree();
  const [texture, setTexture] = useState(null);
  const [planeSize, setPlaneSize] = useState({ width: 16, height: 9 });
  const scalingFactor = useMapStore(state => state.scalingFactor);
  const [intensity, setintensity] = useState()

  useEffect(() => {
    const bgColor = isDarkBackground ? 0x000000 : 0xEEEFF0;
    gl.setClearColor(bgColor, 1);
    camera.position.set(0, 2500, 900);
    camera.near = 0.1;
    camera.far = 5000;
    camera.lookAt(0, 0, 0);
  }, [camera, gl, isDarkBackground]);
  
  
  return (
    <>
      {/* Orbit controls for 3D navigation */}
      <Controls />
      
      {/* Lighting */}
      <ambientLight intensity={1} />
      <directionalLight position={[10, 10, 10]} intensity={1.2} castShadow />
      
      {/* Plane with map texture */}
      {texture && (
        <mesh 
          ref={planeRef} 
          rotation={[-Math.PI / 2, 0, 0]} 
          receiveShadow
          position={[0, 0, 0]}
        >
          <planeGeometry args={[planeSize.width, planeSize.height, 32, 32]} />
          <meshStandardMaterial 
            map={texture} 
            side={THREE.DoubleSide}
          />
        </mesh>
      )}
      
 
    </>
  );
}